import { render, staticRenderFns } from "./radio-thumb.vue?vue&type=template&id=6cc813bf&scoped=true&"
import script from "./radio-thumb.vue?vue&type=script&lang=js&"
export * from "./radio-thumb.vue?vue&type=script&lang=js&"
import style0 from "./radio-thumb.vue?vue&type=style&index=0&id=6cc813bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc813bf",
  null
  
)

export default component.exports